<template lang="pug">
  div
    section.content-header
      h1 組織管理

      ol.breadcrumb
        li
          router-link(:to="{name: 'admin'}")
            i.fa.fa-cog
            | システム管理
        li.active 組織管理

    section.content

      app-messages(:errorMessages="$store.state.base.flashMessages")
      app-messages(:errorMessages="errors", :successMessages="successes")

      mixin btnbar
        .bcard-btnbar.clearfix(class!=attributes.class)
          .pull-left
            app-list-sortable-nav(ref="sortableNav")
              template(slot-scope="{toggleSortMode}")
                router-link.btn.btn-default(:to="{name: 'admin'}", type="button", title="戻る"): i.fa.fa-reply
                |
                |
                router-link.btn.btn-primary(:to="{name: 'group-add', params:{defaultId: parent_id, defaultName: parent_name}, props: true}", type="button", title="組織情報の作成") 組織情報の作成
                |
                |
                .btn-separator
                |
                |
                button.btn.btn-danger(@click="showModalDelete", type="button", title="削除") 削除
                |
                |
                .btn-separator
                |
                |
                .btn-group
                  div(class=attributes.class)
                    a.btn.btn-default.dropdown-toggle(href='#', data-toggle='dropdown', aria-expanded='false', type="button", title="その他の機能")
                      | その他の機能
                      |
                      span.caret
                    ul.dropdown-menu
                      li: a.mock-list-order-button(href='#' @click.prevent="toggleSortMode") 表示順変更
                      li.divider
                      li: router-link(:to="{name: 'group-import'}") 組織情報のインポート
                      li: router-link(:to="{name: 'group-export'}") 組織情報のエクスポート
          .pull-right
            app-pagination(:is-loading="loadingPagination", :pagination="pagination", @change="getList")

      +btnbar

      .row.bcard-table-with-menu
        .col-sm-3.bcard-table-menu-container
          .panel.panel-default(v-show="!tree_init")
            loading
          .panel.panel-default#bcard-group-tree(v-show="tree_init")
            .panel-heading
              h5 組織
            .panel-body
              ul.bcard-tree.bcard-side-tree
                group-tree-item(
                  :onClickName="setParent",
                  :selectedIds="[parent_id]",
                  :refresh="refresh_tree",
                  @complete-refreshing="afterRefreshTree",
                  @complete-initializing="showTree"
                )
            //- 表示順変更モードの場合、マスクをかける
            .sort-mode-overlay(v-if="$store.getState('isListSortMode')")

        .col-sm-9.bcard-table-list-container
          .panel.panel-default
            loading(v-if="loading && tree_height !== 0", :height="tree_height")
            loading(v-else-if="loading")

            .table-responsive.bcard-table-container(v-else-if="list.length > 0")
              table.table.table-striped.table-bordered.bcard-table(:class="{'sort-mode': $store.getState('isListSortMode')}")
                thead
                  tr
                    th.bcard-table-td-chk
                      input(type="checkbox" @change="checkAll(list, $event.target.checked)" :disabled="$store.getState('isListSortMode')")
                    th.th-name 組織名
                    th.th-tel 連絡先
                    th.th-user-count 所属ユーザー数
                app-list-sortable(ref="sortableList", v-model="list", repo="group", :onComplete="refreshTree")
                  tr(
                      v-for="(item, index) in list",
                      :key="item.id",
                      :class="{'selected': isChecked(item.id)}"
                  )
                    td.bcard-table-td-chk
                      input(type="checkbox", :checked="isChecked(item.id)", @change="checkItem(item.id, $event.target.checked)" :disabled="$store.getState('isListSortMode')")
                    td.bcard-ui-userdata
                      router-link(v-if="!$store.getState('isListSortMode')" :to="{name: 'group-edit', params: {id: '' + item.id, item: item, defaultId: parent_id, defaultName: parent_name}}", :title="item.name") {{item.name}}
                      router-link(v-else :to="{}", :title="item.name" event="") {{item.name}}
                    td.bcard-ui-userdata
                      span(:title="item.tel") {{item.tel}}
                    td.text-right {{item.formatted_usercount}}

            //- データなし
            .panel-body.text-center(v-else) 組織情報はありません。
      +btnbar(class="dropup")

    //------------------------------------------------------------
    //- modals
    //------------------------------------------------------------
    app-modal(v-model="modalDelete" type="danger")
      template(slot="title") 組織情報の削除
      h4 選択した組織情報を削除します。よろしいですか？
      template(slot="footer" slot-scope="{close}")
        button.btn.btn-danger(@click="deleteGroups") 削除
        button.btn.btn-default(@click="close") キャンセル

    app-modal(v-model="modalNoitem" type="info")
      h4 削除する組織情報を選択してください。
      template(slot="footer" slot-scope="{close}")
        button.btn.btn-default(@click="close") 閉じる

</template>

<script>
import mixinList from '@/mixins/list'
import AppModal from '@/components/templates/AppModal'
import AppMessages from '@/components/molecules/AppMessages'
import AppPagination from '@/components/molecules/AppPagination'
import AppListSortable from '@/components/organisms/AppListSortable'
import AppListSortableNav from '@/components/organisms/AppListSortableNav'
import GroupTreeItem from '@/components/organisms/GroupTreeItem'
import Loading from '@/components/molecules/Loading'

export default {
  name: 'GroupList',
  components: { AppModal, AppMessages, AppPagination, AppListSortable, AppListSortableNav, GroupTreeItem, Loading },
  mixins: [ mixinList ],
  props: {
    // 追加・変更画面から渡される初期表示の親組織
    defaultId: {type: Number, required: false, default: null},
    defaultName: {type: String, required: false, default: ''}
  },
  data: function () {
    return {
      loadingPagination: true,
      loading: true,
      // 選択中の親組織
      parent_id: null,
      parent_name: null,
      // ダイアログ
      modalDelete: false,
      modalNoitem: false,
      // 組織ツリー更新フラグ
      refresh_tree: false,
      // 組織ツリーの高さ
      tree_height: 0,
      tree_init: false
    }
  },
  created: function () {
    // 追加・変更画面から渡された親組織を取得
    this.parent_id = this.defaultId
    this.parent_name = this.defaultName

    // サイドメニューから遷移した場合
    if (this.$route.params.init) {
      this.getList({page: 1})
    }
    else {
      // 一覧取得
      this.getList({page: this.pagination.current_page || 1})
    }
  },
  methods: {
    // 一覧取得
    getList (options) {
      const vm = this
      const params = { page: options.page || 1 }
      if (this.parent_id) {
        params.parent_id = this.parent_id
      }
      options = options || {}
      // API実行
      this.loading = true
      this.loadingPagination = !options.viaPagination
      this.sendListRequest({
        repo: 'group',
        method: 'getList',
        params,
        finally: function () {
          vm.loading = false
          vm.loadingPagination = false
        }
      })
    },
    // 一括削除
    deleteGroups () {
      const vm = this
      this.sendBulkRequest('group', 'bulkDelete', {
        params: {
          id: this.checkedIds
        },
        onSuccess: function (response) {
          vm.refreshTree()
        }
      })
      // ダイアログを消す
      this.modalDelete = false
    },
    // 組織ツリー側で実行して選択中の親組織を取得する
    setParent (selected) {
      // ロード中の一覧の高さをツリーに合わせる
      this.setTreeHeight()

      this.parent_id = selected.id
      this.parent_name = selected.name
      // 一覧取得
      this.getList({page: 1})
    },
    // ダイアログを表示
    showModalDelete () {
      if (this.hasCheckedItems()) {
        this.modalDelete = true
      }
      else {
        this.modalNoitem = true
      }
    },
    refreshTree () {
      this.refresh_tree = true
    },
    // 組織ツリー更新後の処理
    afterRefreshTree () {
      this.refresh_tree = false
    },
    // 組織ツリーの高さを取得
    setTreeHeight () {
      this.tree_height = document.getElementById('bcard-group-tree').clientHeight
    },
    showTree () {
      this.tree_init = true
    }
  }
}
</script>
<style lang="scss" scoped>
.th-name,
.th-tel {
  width: 200px;
}
.th-user-count {
  width: 9em;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/admin/group/List.vue